import React from 'react';

import styled from '../../../styled';
import { colorsPalette } from '../../../theme';
import { VideoDifficulty } from '../../../types';
import IKImage from '../../IKImage/IKImage';
import { LightTooltip } from '../LightTooltip';

interface DifficultyIconProps {
  difficulty: VideoDifficulty;
}

const DifficultyIcon: React.FC<DifficultyIconProps> = ({ difficulty, ...rest }) => {
  return (
    <StyledLightTooltip
      data-testid="difficultyIcon"
      placement="top"
      title={difficulty?.title}
      {...rest}
    >
      <DifIconWrap>
        <DifIcon path={difficulty?.icon_url} alt={difficulty?.title} draggable={false} />
      </DifIconWrap>
    </StyledLightTooltip>
  );
};

export default DifficultyIcon;

const StyledLightTooltip = styled(LightTooltip)`
  height: 29px;
`;
const DifIconWrap = styled('div')`
  height: 29px;
  width: 29px;
  min-width: 28px;
  max-width: 28px;
  border-radius: 5px;
  background: ${colorsPalette.blue};
  box-sizing: border-box;
`;
const DifIcon = styled(IKImage)`
  width: 100%;
  height: 100%;
  padding: 7px;
`;
